export const checkIsAuthenticated = ({ authentication, profile }) => !!(
  authentication && authentication?.loggedIn
  && profile?.personal.user_wix_id
  // right after signup patient_id is missing
  && profile?.personal.patient_id
);
